import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { useDynamicLocale } from '@/hoslog-intl';

import type { Pagination } from '@/react-query/context/ApiClientContextController';
import { SalesBreakdownData } from '@/services/payment/payment.types';
import { getColumns } from './Column';

export function SalesBreakdownTable({
  data,
  pagination,
  loading,
  onExportRow,
}: {
  data: SalesBreakdownData[];
  pagination: Pagination;
  loading: boolean;
  onExportRow?: (row: SalesBreakdownData, serialNumber: number) => void;
}) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t, onExportRow), [t, onExportRow]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data,
    columns,
    initialState: {
      sorting: [{ id: 'month', desc: true }],
    },
    pageCount,
    meta: {
      title: t('paymentManagement.overview.tabs.salesBreakdown'),
      totalPage: pagination.totalItems,
      pageSize: pagination.pageSize,
      loading,
    },
    getRowId: (originalRow: SalesBreakdownData) => String(originalRow.month),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} />
    </>
  );
}
